import React from 'react';

export const CustomLinkDivider: React.FC = () => {
  return (
    <div className="w-4 h-5">
      <hr className="block w-px h-5 !m-0 border-none bg-gray-600 rounded !mx-auto"></hr>
    </div>
  );
};
